import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { KomitentVozilo } from './komitent-vozilo';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-komitent-vozilo',
  templateUrl: './komitent-vozilo.component.html'
})
export class KomitentVoziloComponent extends BaseModalContainer<KomitentVozilo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentVozilo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

}
